export { EntregaOcurreEdit } from "./edit";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/edit/index.tsx